import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { CurrentService } from '../../../services/current.service';
import { DatasService } from '../../../services/datas.service';
import { GTM } from 'src/app/services/gtm.service';
import { CONTEXT } from 'src/app/enum/context';

@Component({
  selector: 'ng-hbm-bdi-furniture',
  templateUrl: './furniture.component.html'
})
export class FurnitureComponent implements OnInit {

  furnitures: any;

  @Output() onComplete: EventEmitter<void> = new EventEmitter();
  
  constructor(public current: CurrentService, public datas: DatasService, private gtm: GTM) { }

  async ngOnInit(): Promise<void> {
    this.gtm.trackPage(CONTEXT.KITCHEN, 'need-mapping', 'furniture', this.datas.getKitchenGtmData(this.current));
    this.furnitures = await this.datas.getFurnitures();
  }

  selectFurnitureConfiguration(furnitureConfigurationRef: string) {
    this.gtm.trackEvent('click', 'need-mapping', 'furniture-' + furnitureConfigurationRef);
    this.current.furnitureConfiguration = furnitureConfigurationRef;
    this.onComplete.emit();
  }
}
